<template>
  <v-card variant="flat" style="height: 100%; width: 100%; overflow-y: auto;" class="px-4 py-4">
    <v-row class="pa-2">
      <v-col cols="12">
        <h2 class="main_title">Process Flow  <v-icon v-if="userRole < 6" size="small" @click="openDialog">mdi-plus-circle</v-icon></h2>
      </v-col>
      
      <v-col cols="12" class="justify-center">
        <UploadImage @uploaded="upload" showCard="organisation" :documentUpload="true" :selected="showUpload" :processFlow="showUpload"></UploadImage>
      </v-col>
      
      <v-col cols="12" v-if="uploadedImages && uploadedImages.length > 0">
        <div v-for="(item, index) in uploadedImages" :key="index">
        <h2 class="flow_title">{{ item.folderName || 'Uploaded Images' }}</h2>
        <div class="sop-img">
          <div class="imgs">
            <div class="img-wrapper" v-if="item.src">
              <img :src="item.src" alt="Image" :title="item.name" />
              <v-icon v-if="userRole < 6" class="eye-icon" @click="view(item)" :title="item.name">mdi-eye</v-icon>
              <v-icon v-if="userRole < 6" class="delete-icon" @click="deleteImage(index)" :title="item.name">mdi-delete-outline</v-icon>
            </div>
            <div class="empty-folder" v-else>
              <v-icon class="delete-icon" @click="deleteImage(index)">mdi-delete-outline</v-icon>
            </div>
          </div>
        </div>
        </div>
      </v-col>
    </v-row>
  </v-card>

  <v-dialog v-if="viewDialog" v-model="viewDialog" width="900">
    <v-card variant="flat" class="pa-4" style="border-radius: 16px;">
      <div style="display: flex; justify-content: flex-end;">
        <v-icon @click="viewDialog = false" class="cursor-pointer">
          mdi-close
        </v-icon>
      </div>
      <img :src="selectedImage.src" :alt="selectedImage.name" style="width: 100%; height: auto;" />
    </v-card>
  </v-dialog>
  <v-dialog v-if="addFlowDialog" v-model="addFlowDialog" width="900" persistent>
    <v-card variant="flat" class="px-4 pt-3" style="border-radius: 16px;">
        <v-col cols="12">
          <h3> <span style="color: #2b2f8e;">Add</span> Process Flow</h3>
        </v-col>
        <v-form ref="txtcomp">
          <v-col cols="12" class="d-flex ga-4">
            <p>Enter the file name<span style="color: red;">*</span></p>
            <TextFieldComponent  placeholder="Enter the File Name" :rules="[(v) => !!v || 'File name is required']" v-model="folderName" variant="outlined" density="compact" />
          </v-col>
          <v-col cols="12">
            <div class="d-flex justify-end ga-2">
              <v-btn color="grey" variant="outlined" @click="addFlowDialog = false">
                Cancel
              </v-btn>
              <v-btn type="submit" @click="createFolder" color="#2B2F8E">
                Save
              </v-btn>
            </div>
          </v-col>
        </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import UploadImage from '@/menus/UploadImage.vue';
import TextFieldComponent from '@/components/TextFieldComponent.vue';
import moment from 'moment';
import clientDetailsService from '@/api/service/ClientDetails/ClientDetailsService';

export default {
  components: {
    UploadImage,
    TextFieldComponent
  },
  data() {
    return {
      uploadedImages: [],
      viewDialog: false,
      addFlowDialog: false,
      selectedImage: null,
      organisationData: {},
      processFlowData: [],
      folderName: null,
      showUpload: false,
      userData:{},
      userRole: null
    }
  },
  async created() {
    this.getOrganisationData()
    this.userData = JSON.parse(localStorage.getItem('user_details'))
    this.userRole = this.userData && this.userData.roles.role_type
    //alert(this.userRole)
    console.log(this.userData,"usdusd");
  },
  methods: {
    openDialog(){
      this.addFlowDialog = true 
    },
    async getOrganisationData() {
      let $id = this.$route.query.id
      this.organisationData = await clientDetailsService.findOne({ id: $id, collectionName: 'organisation' });
      console.log(this.organisationData,"responsepfpf");
      this.uploadedImages = this.organisationData && this.organisationData.processFlow && this.organisationData.processFlow.length > 0 ? this.organisationData.processFlow : []
    },
    async upload(fileData) {
      let now = moment().format('YYYY-MM-DD HH:mm:ss')
      console.log(fileData,"fileeee");
      const emptyFolder = this.uploadedImages.find(item => !item.src && item.folderName === this.folderName);
      if (emptyFolder) {
        emptyFolder.id = this.uploadedImages.length + 1;
        emptyFolder.src = fileData.src;
        emptyFolder.name = fileData.name;
        emptyFolder.type = fileData.type;
        emptyFolder.docId = fileData.docId;
        emptyFolder.s3Url = fileData.s3Url;
        emptyFolder.created = now;
        emptyFolder.modified = null;
        emptyFolder.created_by = this.userData.id;
        emptyFolder.modified_by = null;
        emptyFolder.active = 1;
        emptyFolder.deleted = 0;
        emptyFolder.deleted_by = null;
      } else {
        fileData.folderName = this.folderName || 'Uploaded Images';
        this.uploadedImages.push(fileData);
      }
      this.organisationData.processFlow = this.uploadedImages;
      let $data = {
          collectionName: 'organisation',
          data: this.organisationData,
          id: this.$route.query.id
      }
      await clientDetailsService.update($data)
      this.showUpload = false
      this.folderName = null
      console.log(this.organisationData,"processflow");
    },
    
    view(image) {
      this.selectedImage = image;
      this.viewDialog = true;
    },
    
    async createFolder() {
      const validation = await this.$refs.txtcomp.validate();
      if (!validation.valid) return;
      
      const newFolder = {
        folderName: this.folderName,
        src: null,
        type: 'folder'
      };
      this.uploadedImages.push(newFolder);
      this.organisationData.processFlow = this.uploadedImages;
      this.addFlowDialog = false;
      this.showUpload = true;
    },
    
    async deleteImage(index) {
      this.uploadedImages.splice(index, 1);
      this.organisationData.processFlow = this.uploadedImages
      let $data = {
          collectionName: 'organisation',
          data: this.organisationData,
          id: this.$route.query.id
      }
      await clientDetailsService.update($data)
      this.showUpload = false
      console.log(this.organisationData,"processflow");
    }
  }
}
</script>

<style scoped>
.main_title {
  color: #000000;
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 16px;
}

.flow_title{
  color: #000000;
  font-size: 18px;
  font-weight: 500px;
  margin-bottom: 14px;
}

.sop-img {
  margin-bottom: 16px;
  border-radius: 10px;
  padding: 10px;
  justify-items: center;
  align-self: center;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: thin;
  height: 226px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.2);
  transition: box-shadow 0.3s ease;
  cursor: pointer;
}

.sop-img:hover {
  box-shadow: 0 8px 16px rgba(0,0,0,0.4);
}

.imgs {
  height: 200px;
  width: 50%;
  /* background-color: #E6EDFF; */
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  position: relative;
}

.img-wrapper {
  position: relative;
  width: 80%;
  height: 80%;
}

.img-wrapper img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 5px;
}

.eye-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  cursor: pointer;
  font-size: 32px;
  color: rgba(0, 0, 0, 0.6);
  background: rgba(255, 255, 255, 0.7);
  border-radius: 50%;
  padding: 5px;
}

.delete-icon {
  position: absolute;
  top: 0%;
  right: 0%;
  transform: translate(50%, -50%);
  cursor: pointer;
  font-size: 20px;
  color: red;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 50%;
  padding: 8px;
}

.empty-folder {
  width: 100%;
  height: 100%;
  background: white;
  border-radius: 5px;
  position: relative;
}
</style>